<template lang="pug">
    v-card()
        v-list.py-0(flat)
            // --------- 搜尋網頁 開關 ---------
            div.br-0.d-flex.align-center.justify-space-between(v-if="$store.state.webSearchEnabled && $store.state.portalWebSearchEnabled" style='height:40px; width:240px;')
                div.ml-4.d-flex.align-center.justify-start()
                    v-img.mr-1(contain height="21.5px" src="@/assets/images/search_web.svg" width="21px")
                    label.label_title(style='color:#444444; font-weight: 400; font-size: 14px;') {{$t('AGENT.SEARCH_WEB')}}
                div.mr-3.d-flex.align-center
                    v-switch.mb-1.keep-white-thumb(v-model='use_web_search' dense flat inset :ripple="false" :color="toggle_setting" @click.stop)
                    label(v-show='use_web_search' style='color:#444444; font-weight: 400; font-size: 14px;') {{$t("GPT_KNOWLEDGE.OPEN_LIB")}}
                    label(v-show='!use_web_search' style='color:#444444; font-weight: 400; font-size: 14px;') {{$t("GPT_KNOWLEDGE.CLOSE_LIB")}}
            v-divider.my-0(v-if="$store.state.webSearchEnabled && $store.state.portalWebSearchEnabled")
            // --------- 知識庫 開關 ---------
            div.br-0.d-flex.align-center.justify-space-between(style='height:40px;  width:240px;')
                div.ml-4.d-flex.align-center.justify-start()
                    v-img.mr-1(contain height="21.5px" src="@/assets/images/knowledge_select.svg" width="21px")
                    label.label_title(style='color:#444444; font-weight: 400; font-size: 14px;') {{$t('AGENT.KNOWLEDGE_LIBS')}}
                div.mr-3.d-flex.align-center()
                    v-switch.mb-1.keep-white-thumb(v-model='use_knowledge_source' dense flat inset :ripple="false" :color="toggle_setting" @click.stop)
                    label(v-show='use_knowledge_source' style='color:#444444; font-weight: 400; font-size: 14px;') {{$t("GPT_KNOWLEDGE.OPEN_LIB")}}
                    label(v-show='!use_knowledge_source' style='color:#444444; font-weight: 400; font-size: 14px;') {{$t("GPT_KNOWLEDGE.CLOSE_LIB")}}
            // --------- 知識庫清單---------
            div.knowledge-inline-list(:class="{ 'kb-list-disabled': !use_knowledge_source }")
                // -------- 全選列 --------
                div.br-0.d-flex.align-center(style='height:40px; width:240px;' @click.stop)
                    div.ml-2.d-flex.align-center.justify-start()
                        v-btn(icon :color="unselectAllKM ? '' : checkbox_setting" :disabled='!use_knowledge_source' @click.stop="activeTriggerAllKM" style='margin-left:-2px;')
                            v-icon(:color="unselectAllKM ? '' : checkbox_setting" size='22') {{ selectALLKMIconDesider() }}
                        label.label_title(style='color:#444444; font-weight: 400; font-size: 14px;') {{$t('GENERAL.SELECTALL')}}
                v-divider.my-0
                div.partial-kmlist()
                    // ======= 收藏區=======
                    template(v-if="knowledgeFavorites.length > 0")
                        div.d-flex.align-center.px-3(style='height:32px;')
                            v-icon(size='16' color='#14C6DE') mdi-star
                            span.ml-1(style='color:#444; font-size:14px; ') {{$t('PORTAL.FAVORITES')}}
                        v-list-item-group(multiple)
                            v-list-item.pl-3.pr-0(v-for="item in knowledgeFavorites" :key="`fav-${item.id}`" @click.stop style="min-height: 36px !important;")
                                template(v-slot:default="{ active }")
                                    v-list-item-action.ma-0.mr-2
                                        v-checkbox.ma-0(v-model='currentselect' :value='item' multiple :value-comparator="(a, b) => a.id === b.id" :color="checkbox_setting" :disabled='!use_knowledge_source')
                                    v-list-item-content.pa-0(style="display: inline;")
                                        v-avatar(size='20' max-height='20' :color='getColorFromKnowledgeName(item.name)' left class="mr-2")
                                            span(style='padding-bottom:1px;') {{item.name.slice(0,1)}}
                                        span(style='color:#444444; font-weight: 400; font-size: 14px;') {{item.name.split('@')[0]}}
                                    v-list-item-action.ma-0
                                        v-btn(icon x-small @click.stop="toggleFavorite(item)")
                                            v-icon(size='16' color='#14C6DE') mdi-star
                        v-divider.my-0
                    // ======= Folder-first Checkbox 樹 =======
                    template(v-for="node in flattenedTree")
                        div.d-flex.align-center.tree-folder-row(
                            v-if="node.type === 'folder'"
                            :key="`folder-${node.id}-d${node.depth}`"
                            :style="treeNodeStyle(node)"
                            @click.stop
                        )
                            v-btn(icon :color="getFolderCheckState(node.id) !== 'none' ? checkbox_setting : ''" :disabled='!use_knowledge_source' @click.stop="toggleFolderSelection(node)" style='margin-left:-2px;')
                                v-icon(:color="getFolderCheckState(node.id) !== 'none' ? checkbox_setting : ''" size='22') {{ getFolderCheckIcon(node.id) }}
                            v-btn.pa-0(icon x-small @click.stop="toggleFolder(node.id)" style='width:18px; height:18px; min-width:18px;')
                                v-icon(size='14' color='#888') {{ expandedFolderIds.includes(String(node.id)) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                            v-img.mr-1(src="@/assets/images/folder-btn.svg" max-height="20" max-width="20" contain)
                            span.tree-node-name.ellipsis-single(style='color:#444444; font-weight: 400; font-size: 14px;') {{ node.name }}
                        v-hover(v-else-if="node.type === 'library'" :key="`lib-${node.id}-d${node.depth}`" v-slot="{ hover }")
                            div.d-flex.align-center(
                                :style="treeNodeStyle(node)"
                                @click.stop
                            )
                                v-checkbox.mr-0.ml-3.my-0(v-model='currentselect' :value='libraryNodeMap[node.id]' multiple :value-comparator="(a, b) => a.id === b.id" :color="checkbox_setting" :disabled='!use_knowledge_source' @click.stop)
                                v-avatar.ml-3(size='20' max-height='20' :color='getColorFromKnowledgeName(node.name)' left class="mr-2")
                                    span(style='padding-bottom:1px;' ) {{ node.name.slice(0,1) }}
                                span.tree-node-name.ellipsis-single(style='color:#444444; font-weight: 400; font-size: 14px;' :title="node.name") {{ node.name }}
                                v-spacer
                                v-btn(v-show="hover || localFavoriteIds.includes(node.id)" icon x-small @click.stop="toggleFavorite(node)" style='margin-right:4px;')
                                    v-icon(size='16' :color="localFavoriteIds.includes(node.id) ? '#14C6DE' : '#bbb'") {{ localFavoriteIds.includes(node.id) ? 'mdi-star' : 'mdi-star-outline' }}
                    // ======= 私人知識庫 =======
                    div.p1-en-regular.ml-2(style='color:#444444; font-weight: 400; font-size: 14px;' v-show="knowledgeListPrivate.length !== 0") {{$t("PORTAL.MY_KNOWLEDGE")}}
                    v-list-item-group(multiple v-show="knowledgeListPrivate.length !== 0")
                        v-list-item.private-list.pr-0.pl-3(v-for="item in knowledgeListPrivate" :key="item.id" @click.stop style="min-height: 38px !important;")
                            template(v-slot:default="{ active }")
                                v-list-item-action.mr-2.my-2
                                    v-checkbox.ma-0(v-model='currentselect' :value='item' multiple :value-comparator="(a, b) => a.id === b.id" :color="checkbox_setting" :disabled='!use_knowledge_source')
                                v-list-item-content.pa-0(style="display: inline;")
                                    v-avatar(size='20' max-height='20' :color='getColorFromKnowledgeName(item.name)' left class="mr-2")
                                        span(style='padding-bottom:1px;') {{ item.name.slice(0,1) }}
                                    span(style='color:#444444; font-weight: 400; font-size: 14px;' :title="item.name.split('@')[0]") {{ item.name.split('@')[0] }}
                                v-list-item-action.ma-0
                                    v-hover(v-slot="{ hover }")
                                        v-btn(icon x-small @click.stop="toggleFavorite(item)")
                                            v-icon(size='16' :color="item.is_favorite ? '#14C6DE' : (hover ? '#bbb' : 'transparent')") {{ item.is_favorite ? 'mdi-star' : 'mdi-star-outline' }}
            v-card-actions.flex-row-reverse.pt-0(v-if="is_upsert")
                v-btn(text :color="confirm_knowledge_btn" :disabled="generating || !use_knowledge_source", @click="upsertQuestionData") {{$t("PORTAL.APPLY")}}
</template>

<script>
import Vue from 'vue';
import PreferenceService from "@/services/PreferenceService";
import KnowledgeLibraryService from "@/services/KnowledgeLibraryService";

export default Vue.extend({
    props: {
        knowledgeList: {
            type: Array,
            required: true,
        },
        knowledgeListPrivate: {
            type: Array,
            required: true,
        },
        allKnowledgeColor: {
            type: Array,
            required: true
        },
        selectedKnowledgeLibs: {
            type: Array,
            required: true
        },
        is_upsert: {
            type: Boolean,
            default: () => false
        },
        generating: {
            type: Boolean,
            default: () => false
        },
        canSearchWeb: {
            type: Boolean,
            default: () => false
        },
        canUseKB: {
            type: Boolean,
            default: () => true
        },
        folderTreeOptions: {
            type: Array,
            required: true,
            default: () => []
        },
    },
    async created() {
        await this.getPortalColorSetting();
    },
    data() {
        return {
            unselectAllKM: false,
            // 客製外觀參數
            toggle_setting: document.documentElement.style.getPropertyValue('--toggle_setting'),
            checkbox_setting: document.documentElement.style.getPropertyValue('--checkbox_setting'),
            confirm_knowledge_btn: document.documentElement.style.getPropertyValue('--confirm_knowledge_btn'),
            currentselect: [],
            expandedFolderIds: [],
            // 本地收藏 ID 清單：用 reactive array 取代依賴 item.is_favorite，
            // 避免 flattenedTree 的淺複製物件導致 computed 無法感知變更
            localFavoriteIds: [],
        }
    },
    computed: {
        use_web_search: {
            get() { return this.canSearchWeb },
            set(val) { this.$emit('usewebsetting', val) }
        },
        use_knowledge_source: {
            get() { return this.canUseKB },
            set(val) { this.$emit('useknowledgesetting', val) }
        },
        // Folder-first 樹狀結構攤平為列表
        // 只展開在 expandedFolderIds 中的資料夾
        flattenedTree() {
            const result = []
            const flatten = (nodes, depth = 0) => {
                for (const node of (nodes || [])) {
                    result.push({ ...node, depth })
                    if (node.type === 'folder' && this.expandedFolderIds.includes(String(node.id))) {
                        flatten(node.children || [], depth + 1)
                    }
                }
            }
            flatten(this.folderTreeOptions)
            return result
        },
        knowledgeFavorites() {
            return [...this.knowledgeList, ...this.knowledgeListPrivate]
                .filter(item => this.localFavoriteIds.includes(item.id))
        },
        // ===== 建立 library id → 原始 folderTreeOptions 節點的映射表 =====
        // 確保 v-checkbox 的 :value 永遠使用穩定的物件 reference，
        // 避免 flattenedTree recompute（展開/收合資料夾）時產生新 spread 物件，
        // 觸發 Vuetify 2 的 value watcher 把 currentselect 覆蓋掉。
        libraryNodeMap() {
            const map = {}
            const traverse = (nodes) => {
                for (const node of (nodes || [])) {
                    if (node.type === 'library') {
                        map[node.id] = node
                    } else if (node.type === 'folder') {
                        traverse(node.children || [])
                    }
                }
            }
            traverse(this.folderTreeOptions)
            return map
        },
    },
    methods: {
        // ===== 全選邏輯（使用 Set 計算唯一 ID）=====
        selectAllKMCheck() {
            const uniqueIds = new Set([
                ...this.knowledgeList.map(i => i.id),
                ...this.knowledgeListPrivate.map(i => i.id),
            ])
            return uniqueIds.size > 0 && this.currentselect.length === uniqueIds.size
        },
        selectSomeKMCheck() {
            return this.currentselect.length > 0 && !this.selectAllKMCheck()
        },
        selectALLKMIconDesider() {
            if (this.selectAllKMCheck()) {
                this.unselectAllKM = false
                return 'mdi-checkbox-marked'
            } else if (this.selectSomeKMCheck()) {
                this.unselectAllKM = false
                return 'mdi-minus-box'
            } else {
                this.unselectAllKM = true
                return 'mdi-checkbox-blank-outline'
            }
        },
        // 全選 / 全取消
        activeTriggerAllKM() {
            if (this.selectAllKMCheck() || this.selectSomeKMCheck()) {
                this.currentselect = []
            } else {
                const seen = new Map()
                ;[...this.knowledgeList, ...this.knowledgeListPrivate].forEach(item => {
                    if (!seen.has(item.id)) seen.set(item.id, item)
                })
                this.currentselect = [...seen.values()]
            }
        },

        // ===== 樹狀節點縮排樣式（depth > 0 加左 guide line）=====
        treeNodeStyle(node) {
            if (node.depth === 0) {
                return { paddingLeft: node.type === 'folder' ? '6px' : '0', minHeight: '36px' }
            }
            const ml = (node.depth - 1) * 16 + 14
            return {
                marginLeft: ml + 'px',
                // borderLeft: '2px solid #e0e0e0',
                paddingLeft: node.type === 'folder' ? '6px' : '0',
                minHeight: '36px',
            }
        },

        // ===== 資料夾展開 / 收合=====
        toggleFolder(folderId) {
            const id = String(folderId)
            const idx = this.expandedFolderIds.indexOf(id)
            if (idx === -1) {
                this.expandedFolderIds.push(id)
            } else {
                this.expandedFolderIds.splice(idx, 1)
            }
        },

        // ===== 資料夾 Checkbox 狀態 =====
        // 遞迴取得節點下所有 library 葉節點
        getAllLibsUnderNode(node) {
            const libs = []
            const traverse = (children) => {
                for (const child of (children || [])) {
                    if (child.type === 'library') {
                        libs.push(child)
                    } else if (child.type === 'folder') {
                        traverse(child.children || [])
                    }
                }
            }
            traverse(node.children || [])
            return libs
        },
        getFolderCheckState(folderId) {
            // 在 flattenedTree 中找出原始 node（含 children）
            const rawNode = this.findNodeInTree(this.folderTreeOptions, String(folderId))
            if (!rawNode) return 'none'
            const libs = this.getAllLibsUnderNode(rawNode)
            if (libs.length === 0) return 'none'
            const selectedCount = libs.filter(lib =>
                this.currentselect.some(s => s.id === lib.id)
            ).length
            if (selectedCount === 0) return 'none'
            if (selectedCount === libs.length) return 'all'
            return 'some'
        },
        getFolderCheckIcon(folderId) {
            const state = this.getFolderCheckState(folderId)
            if (state === 'all') return 'mdi-checkbox-marked'
            if (state === 'some') return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        // 勾選 / 取消資料夾下所有子知識庫
        toggleFolderSelection(folderNode) {
            const rawNode = this.findNodeInTree(this.folderTreeOptions, String(folderNode.id))
            if (!rawNode) return
            const libs = this.getAllLibsUnderNode(rawNode)
            if (libs.length === 0) return
            const state = this.getFolderCheckState(folderNode.id)
            if (state === 'all') {
                const libIds = new Set(libs.map(l => l.id))
                this.currentselect = this.currentselect.filter(s => !libIds.has(s.id))
            } else {
                const alreadySelectedIds = new Set(this.currentselect.map(s => s.id))
                const toAdd = libs.filter(l => !alreadySelectedIds.has(l.id))
                this.currentselect = [...this.currentselect, ...toAdd]
            }
        },
        // 在樹中遞迴查找節點（by id）
        findNodeInTree(nodes, id) {
            for (const node of (nodes || [])) {
                if (String(node.id) === id) return node
                if (node.type === 'folder') {
                    const found = this.findNodeInTree(node.children || [], id)
                    if (found) return found
                }
            }
            return null
        },

        // ===== 收藏功能=====
        // 同步更新 localFavoriteIds 以及原始 knowledgeList/knowledgeListPrivate 的 is_favorite
        _syncFavoriteState(id, isFavorite) {
            const idx = this.localFavoriteIds.indexOf(id)
            if (isFavorite && idx === -1) this.localFavoriteIds.push(id)
            else if (!isFavorite && idx !== -1) this.localFavoriteIds.splice(idx, 1)
            // 同步原始物件的 is_favorite（flattenedTree 是淺複製，需找到原始 ref 來更新）
            const original = [...this.knowledgeList, ...this.knowledgeListPrivate].find(k => k.id === id)
            if (original) this.$set(original, 'is_favorite', isFavorite)
        },
        async toggleFavorite(item) {
            const wasFavorite = this.localFavoriteIds.includes(item.id)
            const newVal = !wasFavorite
            // 樂觀更新
            this._syncFavoriteState(item.id, newVal)
            try {
                if (newVal) {
                    await KnowledgeLibraryService.addFavorite(item.id)
                } else {
                    await KnowledgeLibraryService.removeFavorite(item.id)
                }
            } catch (e) {
                // API 失敗時還原
                this._syncFavoriteState(item.id, wasFavorite)
                this.$emit('showSnackbar', this.$t('PORTAL.FAVORITE_ERROR') || '收藏操作失敗')
            }
        },

        // ===== 顏色 / 設定 =====
        async getPortalColorSetting() {
            await PreferenceService.getPortalColorSetting().then((response) => {
                const color_setting = response.data
                if (color_setting) {
                    this.toggle_setting = color_setting.toggle_setting
                    this.checkbox_setting = color_setting.checkbox_setting
                    this.confirm_knowledge_btn = color_setting.confirm_knowledge_btn
                } else {
                    this.toggle_setting = '#14C6DE'
                    this.checkbox_setting = '#14C6DE'
                    this.confirm_knowledge_btn = '#14C6DE'
                }
            })
        },
        getColorFromKnowledgeName(knowledge_name) {
            const color_data = this.allKnowledgeColor.find(item => item.name == knowledge_name)
            return color_data ? color_data.color : 'aliceBlue'
        },
        upsertQuestionData() {
            const apply_data = {
                use_web_search: this.use_web_search,
                use_knowledge_source: this.use_knowledge_source,
                // knowledge_folder 已移除（Task 2：UI 不再切換 folder mode）
            }
            this.$emit('upsertQuestion', apply_data)
        },
    },
    watch: {
        // 父層傳入新資料時，重新同步 localFavoriteIds
        knowledgeList: {
            immediate: true,
            handler(list) {
                list.forEach(item => {
                    const idx = this.localFavoriteIds.indexOf(item.id)
                    if (item.is_favorite && idx === -1) this.localFavoriteIds.push(item.id)
                    else if (!item.is_favorite && idx !== -1) this.localFavoriteIds.splice(idx, 1)
                })
            },
        },
        knowledgeListPrivate: {
            immediate: true,
            handler(list) {
                list.forEach(item => {
                    const idx = this.localFavoriteIds.indexOf(item.id)
                    if (item.is_favorite && idx === -1) this.localFavoriteIds.push(item.id)
                    else if (!item.is_favorite && idx !== -1) this.localFavoriteIds.splice(idx, 1)
                })
            },
        },
        selectedKnowledgeLibs: {
            immediate: true,
            handler(newVal) {
                this.currentselect = [...newVal]
            }
        },
        currentselect: {
            handler(newVal) {
                if (JSON.stringify(newVal) !== JSON.stringify(this.selectedKnowledgeLibs)) {
                    this.$emit('returnselectedKnowledge', newVal)
                }
            },
            deep: true
        },
    }
})
</script>


<style scoped lang="scss">
    .v-menu__content {
      box-shadow: 0px 0px 8px #9999994D;
    }
    ::v-deep .v-list-item{
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      letter-spacing: 0.5px;
      color: #444 !important;
    }
    .knowledge-inline-list {
        height: 250px;
        overflow-y: auto;
        overflow-x: hidden;
        width: 240px;
    }
    .knowledge-inline-list::-webkit-scrollbar {
        width: 6px;
    }
    .knowledge-inline-list::-webkit-scrollbar-track {
        background: #F4F4F4 !important;
    }
    .knowledge-inline-list::-webkit-scrollbar-thumb {
        background: rgba(153, 153, 153, 0.3);
        border-radius: 10px;
    }
    .tree-folder-row {
        cursor: pointer;
        &:hover {
            background: rgba(0,0,0,0.03);
        }
    }
    .tree-node-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 150px;
    }
    .theme--light.v-input {
        color: rgba(0, 0, 0, 0.54);
    }
    ::v-deep .v-list-item::before {
        display: none !important;
    }
    ::v-deep .v-list-item .v-ripple__container {
        display: none !important;
    }
    .knowledge-inline-list.kb-list-disabled {
        opacity: 0.45;
        pointer-events: none;
    }
    .knowledge-inline-list ::v-deep .v-input--selection-controls__input {
        width: 20px;
        height: 20px;
        margin-right: 4px;
        .v-icon {
            font-size: 20px !important;
        }
    }
    .knowledge-inline-list ::v-deep .v-input__control  {
        flex-direction: row;
        flex-wrap: nowrap;
    }
    .ellipsis-single{
        display: -webkit-box;
        -webkit-line-clamp: 1; /* 部分舊版瀏覽器需要此設定 */
        line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
    }
</style>
